import { useSelector } from "react-redux";
import { deleteStockReservation, requestDeletingReservation, selectState } from "../inputSlice";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";

const DeleteReservationModal = () => {
  const { deleteReservation } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(requestDeletingReservation(undefined));
  };

  const doDelete = async () => {
    try {
      if (deleteReservation !== undefined) {
        dispatch(deleteStockReservation(deleteReservation.reservationId));
        toast.success("Uspesno obrisan.");
        close();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={deleteReservation !== undefined}
      title="Brisanje rezervacije"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete rezervaciju i vratite rezervisane količine?
      </p>
    </Modal>
  );
};

export default DeleteReservationModal;
